// extracted by mini-css-extract-plugin
module.exports = {"SaveElectric":"SaveElectric_SaveElectric__NxRKP"};